import { Text } from "@certn/cascadia-react";
import { CascadiaColor } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Button } from "react-aria-components";

interface SummaryItem {
  label: string;
  number: string | number;
  testID?: string;
  onPress?: () => void;
}

export function DashboardSummaryItem(props: SummaryItem) {
  const { label, number, testID, onPress } = props;

  let color: CascadiaColor = "text-base";
  switch (label) {
    case "Active":
      color = "text-accent-tofino";
      break;
    case "Review":
      color = "text-warning";
      break;
    case "Complete":
      color = "text-accent-green";
      break;
    case "Action":
      color = "text-danger";
      break;
  }

  return (
    <Button
      onPress={onPress}
      className={styles.buttonContent}
      data-testid={testID}
    >
      <Text style="global/metric-medium" align="center">
        {number}
      </Text>
      <Text style="global/metric-label" align="center" color={color}>
        {label}
      </Text>
    </Button>
  );
}

const styles = {
  buttonContent: css({
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    background: "transparent",
    border: "none",
    minHeight: "72px",
    flexGrow: 1,
    outline: "none",
    borderRadius: "var(--border-radius-3)",
    padding: "var(--space-2)",
    cursor: "pointer",
    "&[data-focus-visible]": {
      boxShadow: "var(--focus-action)",
    },
    "&[data-hovered]": {
      backgroundColor: "var(--background-ghost-hover)",
    },
  }),
};
